import { call, put, takeLatest, delay } from 'redux-saga/effects';
import {
  GET_SEARCH,
  getSearchAsync,
  GET_RELATED_WORD,
  getRelatedWordAsync,
  GET_POPULAR_KEYWORD,
  getPopularKeywordAsync,
  GET_WIKI,
  getWikiAsync,
  getSpellCheckerAsync,
  GET_SPELL_CHECKER,
  getSearchImageAsync,
  GET_SEARCH_IMAGE,
  GET_SEARCH_ATTACH,
  getSearchAttachmentAsync,
} from './actions';
import {
  apiGetSearch,
  apiGetRelatedWord,
  apiGetPopularKeyword,
  apiGetWiki,
  apiGetSpellchecker,
  apiGetSearchImage,
  apiGetSearchAttach,
} from '../../lib/tabResult/api';
import {
  GetSearchType,
  GetRelatedWordType,
  GetPopularKeywordType,
  GetWikiType,
  GetSpellCheckerType,
  GetSearchImageType,
  GetSearchAttachResponseType,
} from '../../lib/tabResult/type';

function* getSearchSaga(action: ReturnType<typeof getSearchAsync.request>) {
  try {
    yield delay(500);
    const data: GetSearchType = yield call(apiGetSearch, action.payload);
    yield put(getSearchAsync.success(data));
  } catch (error) {
    yield put(getSearchAsync.failure(error));
  }
}

function* getSearchImageSaga(
  action: ReturnType<typeof getSearchImageAsync.request>
) {
  try {
    yield delay(500);
    const data: GetSearchImageType = yield call(
      apiGetSearchImage,
      action.payload
    );
    yield put(getSearchImageAsync.success(data));
  } catch (error) {
    yield put(getSearchImageAsync.failure(error));
  }
}

function* getSearchAttachSaga(action: ReturnType<typeof getSearchAttachmentAsync.request>) {
  try {
    const data: GetSearchAttachResponseType = yield call(
      apiGetSearchAttach,
      action.payload
      );
    yield put(getSearchAttachmentAsync.success(data));
  } catch (error) {
    yield put(getSearchAttachmentAsync.failure(error));
  }
}
function* getRelatedWordSaga(
  action: ReturnType<typeof getRelatedWordAsync.request>
) {
  try {
    yield delay(500);
    const data: GetRelatedWordType = yield call(
      apiGetRelatedWord,
      action.payload
    );
    yield put(getRelatedWordAsync.success(data));
  } catch (error) {
    yield put(getRelatedWordAsync.failure(error));
  }
}

function* getPopularKeywordSaga(
  action: ReturnType<typeof getPopularKeywordAsync.request>
) {
  try {
    yield delay(500);
    const data: GetPopularKeywordType = yield call(
      apiGetPopularKeyword,
      action.payload
    );
    yield put(getPopularKeywordAsync.success(data));
  } catch (error) {
    yield put(getPopularKeywordAsync.failure(error));
  }
}

function* getWikiSaga(action: ReturnType<typeof getWikiAsync.request>) {
  try {
    yield delay(500);
    const data: GetWikiType = yield call(apiGetWiki, action.payload);
    yield put(getWikiAsync.success(data));
  } catch (error) {
    yield put(getWikiAsync.failure(error));
  }
}

function* getSpellCheckerSaga(
  action: ReturnType<typeof getSpellCheckerAsync.request>
) {
  try {
    yield delay(500);
    const data: GetSpellCheckerType = yield call(
      apiGetSpellchecker,
      action.payload
    );
    yield put(getSpellCheckerAsync.success(data));
  } catch (error) {
    yield put(getSpellCheckerAsync.failure(error));
  }
}

export default function* tabAISaga() {
  yield takeLatest(GET_SEARCH, getSearchSaga);
  yield takeLatest(GET_SEARCH_ATTACH, getSearchAttachSaga);
  yield takeLatest(GET_SEARCH_IMAGE, getSearchImageSaga);
  yield takeLatest(GET_RELATED_WORD, getRelatedWordSaga);
  yield takeLatest(GET_POPULAR_KEYWORD, getPopularKeywordSaga);
  yield takeLatest(GET_WIKI, getWikiSaga);
  yield takeLatest(GET_SPELL_CHECKER, getSpellCheckerSaga);
}
